import { Box, type CheckboxProps, Stack, Typography } from "@mui/material";
import { BlCheckboxInput as Checkbox } from "Components/_Shared/Inputs/BlCheckboxInput";
import { Spacing } from "Infrastructure/Themes/Themes";
import { get } from "lodash-es";
import type * as React from "react";
import { type Control, Controller, type FieldErrors, type FieldPath, type FieldValues } from "react-hook-form";
import { StyledFormControl, StyledFormLabelWrapper } from "./FormStyles";

type Props<FormType extends FieldValues> = Omit<CheckboxProps, "onChange"> & {
  name: FieldPath<FormType>;
  label?: string | React.JSX.Element;
  text?: string;
  control: Control<FormType, object>;
  errors: FieldErrors<FormType>;
  isLabelFirst?: boolean;
  hasFilterStyle?: boolean;
  hasErrorMessage?: boolean;
  onChange?: (value: boolean) => void;
};

export const BlCheckboxInput = <T extends object>(props: Props<T>) => {
  const { control, errors, name, isLabelFirst, onChange, text, label, ...rest } = props;
  return (
    <>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange: controllerOnChange, value } }) => {
          const onValueChange = (val: boolean) => {
            controllerOnChange(val);
            if (onChange) {
              onChange(val);
            }
          };

          const fieldError = get(errors, name as string);

          return (
            <>
              {!!label && (
                <StyledFormLabelWrapper htmlFor={name}>
                  <Stack direction="row" gap={1}>
                    <Typography fontWeight={500} variant="body2" mb={Spacing.S}>
                      {label}
                    </Typography>
                  </Stack>
                </StyledFormLabelWrapper>
              )}
              <Box display="flex" alignItems="center">
                <Checkbox
                  onChange={(e) => onValueChange(e.target.checked)}
                  value={value}
                  checked={value === true}
                  name={name}
                  fieldError={fieldError}
                  isLabelFirst={isLabelFirst}
                  {...rest}
                />
                <Typography variant="body2" fontWeight={500} lineHeight={1} ml={1}>
                  {text}
                </Typography>
              </Box>
            </>
          );
        }}
      />
    </>
  );
};
